import { Outlet, RouteObject, RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.scss";
import GlobalError from "./components/GlobalError";
import Page from "./Page";
import { ErrorBoundary } from "react-error-boundary";

const RouterLayout = () => (
  <>
    <Outlet />
  </>
);

const routes: RouteObject[] = [
  { path: "/register", Component: Page },
  { path: "*", Component: Page }
];

const router = createBrowserRouter(
  [
    {
      element: <RouterLayout />,
      children: routes
    }
  ],
  { basename: "/wallet-login" }
);

function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalError}>
      <RouterProvider router={router} />;
    </ErrorBoundary>
  );
}

export default App;
